import '../styles/index.css';

export interface DateChangeDisplayProps {
  date: string;
}

export function DateChangeDisplay({ date }: DateChangeDisplayProps) {
  return (
    <div className="pawa-date-container pawa-chat-item">
      <div className="pawa-date-badge">
        <div className="pawa-date-icon">
          <span>📅</span>
        </div>
        <div className="pawa-date-text">{date}</div>
      </div>
    </div>
  );
}
